<script>
import {
  required
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'CreateStock',
  props:[
    "modelOpen",
    "data"
  ],
  data() {
        return {
            userList:[],
            form:{
                user_id: '',
                marka: '',
                model: '',
                plaka: '',
                seyrusefer: '',
                muayene: '',
                sigorta: '',
            },
            submitted: false,
            loading:false,
        };  
    },
    watch:{
        modelOpen(){
            this.form = {
                user_id: '',
                marka: '',
                model: '',
                plaka: '',
                seyrusefer: '',
                muayene: '',
                sigorta: '',
            }
            this.form = this.data
            this.getUserList();
        },
    },
    validations: {
        form: {
            user_id :required
        },
    },
    methods: {
        getUserList(){
            this.$http.post('/users')
            .then(response => { this.userList = response.data.data })
        },
        update(){
            this.$http.put(`/vehicles/${this.data.id}`, {
                ...this.form
            })
            .then(response => {  return notify.success(response.data.message) })
            this.$emit('loadItems');
        },
        store(){
            this.$http.post(`/vehicles/store`, {
                ...this.form
            })
            .then(response => {  return notify.success(response.data.message) })
            this.$emit('loadItems');
        },
        remove(){
            this.$http.delete(`/vehicles` + this.data.id)
            .then(response => {  return notify.success(response.data.message) })
            this.$emit('loadItems');
        },
        close() {
            this.$parent.$bvModal.hide('vehicle_modal')
        },
      
    },
};
</script>

<template>
  <b-modal 
        size="md"
        id="vehicle_modal"
        title="Araç Ekleme"  
        no-close-on-backdrop 
        hide-footer>
        <div class="row mt-2">
            <label class="col-sm-4 col-form-label" for="marka">Marka</label>
            <div class="col-sm-8">
              <input id="marka" type="text" class="form-control" v-model="form.marka"
                    :class="{'is-invalid': submitted && $v.form.marka.$error}" >
                <div
                    v-if="submitted && !$v.form.marka.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <label class="col-sm-4 col-form-label" for="model">Model</label>
            <div class="col-sm-8">
              <input id="model" type="text" class="form-control" v-model="form.model"
                    :class="{'is-invalid': submitted && $v.form.model.$error}" >
                <div
                    v-if="submitted && !$v.form.model.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <label class="col-sm-4 col-form-label" for="name">Kime Zimmetlenecek</label>
            <div class="col-sm-8">
                <select 
                    id="name"
                    class="form-control form-select"  
                    :class="{'is-invalid': submitted && $v.form.user_id.$error}" 
                    v-model="form.user_id">
                    <option value="">Seçiniz</option>
                    <option :value="user.id" v-for="(user,i) in userList" :key="i">{{ user.name }}</option>
                </select>
                <div
                    v-if="submitted && !$v.form.user_id.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <label class="col-sm-4 col-form-label" for="plaka">Plaka</label>
            <div class="col-sm-8">
              <input id="plaka" type="text" class="form-control" v-model="form.plaka"
                    :class="{'is-invalid': submitted && $v.form.plaka.$error}" >
                <div
                    v-if="submitted && !$v.form.plaka.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <label class="col-sm-4 col-form-label" for="seyrusefer">Seyrüsefer</label>
            <div class="col-sm-8">
              <input id="seyrusefer" type="date" class="form-control" v-model="form.seyrusefer"
                    :class="{'is-invalid': submitted && $v.form.seyrusefer.$error}" >
                <div
                    v-if="submitted && !$v.form.seyrusefer.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <label class="col-sm-4 col-form-label" for="sigorta">Sigorta</label>
            <div class="col-sm-8">
              <input id="sigorta" type="date" class="form-control" v-model="form.sigorta"
                    :class="{'is-invalid': submitted && $v.form.sigorta.$error}" >
                <div
                    v-if="submitted && !$v.form.sigorta.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <label class="col-sm-4 col-form-label" for="muayene">Muayene</label>
            <div class="col-sm-8">
              <input id="muayene" type="date" class="form-control" v-model="form.muayene"
                    :class="{'is-invalid': submitted && $v.form.muayene.$error}" >
                <div
                    v-if="submitted && !$v.form.muayene.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <div>
                <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
            </div>
            <div class="d-flex justify-content-between">
                <b-button variant="light" @click="close()">Vazgeç</b-button>
                <b-button 
                    v-if="form.id"
                    type="submit" 
                    variant="warning" 
                    class="ms-1"
                    @click="update()"
                    >Güncelle
                </b-button>
                <b-button 
                    v-else
                    type="submit" 
                    variant="success" 
                    class="ms-1"
                    @click="store()"
                    >Oluştur
                </b-button>
            </div>
        </div>
</b-modal>
</template>  